import { z } from 'zod';

import { VANITY_ERROR_MAP } from '../../../../../constants';

export const schema = z
	.string()
	.min(10, { message: VANITY_ERROR_MAP.INVALID_LENGTH.code })
	.max(100, { message: VANITY_ERROR_MAP.INVALID_LENGTH.code })
	.refine((val) => !val.match(/[.,?/#!$%^&*;:{}=`~()[\]<>]/), {
		message: VANITY_ERROR_MAP.INVALID_URL.code,
	})
	.refine((val) => !val.match(/\s/), { message: VANITY_ERROR_MAP.INVALID_URL.code });
